module.exports = __webpack_public_path__ + "static/media/GracelingBookCover.c4ebc7a4.jpg";